import { XingContainerComponent } from './xing-container.component';

export type XingContainerComponentT = new (...args: any[]) => XingContainerComponent;

export const XingComponentLoader: () => Promise<XingContainerComponentT> = () =>
  import('./xing-container.component').then(k => k.XingContainerComponent);
